import { render, staticRenderFns } from "./refundFailureList.vue?vue&type=template&id=fa8de66e&scoped=true"
import script from "./refundFailureList.vue?vue&type=script&lang=js"
export * from "./refundFailureList.vue?vue&type=script&lang=js"
import style0 from "./refundFailureList.vue?vue&type=style&index=0&id=fa8de66e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa8de66e",
  null
  
)

export default component.exports